<script lang="ts" setup>
import { ModalsContainer } from 'vue-final-modal';
import PopupsView from '@/containers/PopupsView.vue';
import RouteLoadingIndicator from '@/components/RouteLoadingIndicator.vue';
import RouteAccessibility from '@/components/RouteAccessibility.vue';
import { useNotificationsSubscription } from '@/composables/use-notifications-subscription.ts';
import { initializeWebPush } from '@/composables/use-web-push.ts';
import { initializePwa } from '@/composables/use-pwa.ts';
import PwaStatus from '@/components/PwaStatus.vue';
import { captureLaunchAttribution } from '@/utils/launch-attribution.ts';
import { onMounted, watch } from 'vue';
import RouteViewTransition from '@/components/navigation/RouteViewTransition.vue';
import { usePB } from '@/composables/database/use-pocket-base.ts';
import { normalizeLocale, useI18n } from '@/i18n/index.ts';
import type { UsersRecord } from '@/types/pocketbase-types.ts';
import { useFeatureFlag } from '@/composables/use-feature-flags.ts';

const launchAnalyticsEnabled = useFeatureFlag('launch_analytics');
const webPushEnabled = useFeatureFlag('web_push');
onMounted(() => {
  if (launchAnalyticsEnabled.value) captureLaunchAttribution(window.location.search);
});
const pb = usePB();
const { setLocale } = useI18n();
watch(
  () => (pb.currentUser.value as UsersRecord | undefined)?.locale,
  (savedLocale) => {
    const normalized = normalizeLocale(savedLocale);
    if (normalized) setLocale(normalized);
  },
  { immediate: true },
);

// Initialize notifications subscription
useNotificationsSubscription(() => {});
if (webPushEnabled.value) initializeWebPush();
initializePwa();
</script>

<template>
  <a
    class="skip-link"
    href="#main-content"
    >Skip to main content</a
  >
  <RouteAccessibility />
  <RouteViewTransition />
  <ModalsContainer />
  <PopupsView />
  <RouteLoadingIndicator />
  <PwaStatus />
</template>

<style scoped></style>
